import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link } from "react-router-dom";
import "./navbar.css";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../../redux/apiCalls/authApiCall";
import person from "../../../images/doctors/person.png"

function NavbarPro() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  return (
    <Navbar
      expand="lg"
      style={{ backgroundColor: "#014160" }}
      className="p-3 navbar-dark fixed-top"
    >
      <Container>
        <Navbar.Brand
          style={{ fontSize: "22px", fontWeight: "bold" }}
          as={Link}
          to="/"
        >
          أطباء اسيوط
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav
            className="me-auto my-2 my-lg-0"
            style={{ maxHeight: "100px" }}
            navbarScroll
          >
            <Nav.Link className="ms-3" as={Link} to="/">
              الرئيسية
            </Nav.Link>
            <Nav.Link className="ms-3" as={Link} to="/doctors">
              الاطباء
            </Nav.Link>

            {user && (
              <Nav.Link className="ms-3" as={Link} to="/create">
                اضافة طبيب
              </Nav.Link>
            )}
            {user?.isAdmin && (
              <Nav.Link className="ms-3" as={Link} to="/admin-dashboard">
                الادمن
              </Nav.Link>
            )}
            <Nav.Link className="ms-3" as={Link} to="/about">
              من نحن
            </Nav.Link>

            {user && (
              <NavDropdown id="navbarScrollingDropdown">
                <NavDropdown.Item as={Link} to={`/profile/${user?._id}`}>
                  <span className="nav-bar-item-span">الملف الشخصى</span>
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action5">
                  <span
                    onClick={() => dispatch(logoutUser())}
                    className="nav-bar-item-span"
                  >
                    الخروج من الموقع
                  </span>
                </NavDropdown.Item>
              </NavDropdown>
            )}

            {user ? (
              <>
                <div className="nav-user-info">
                  <span>{user?.username.substr(0, 25)}</span>
                  <Link to={`/profile/${user?._id}`}>
                    <img src={ person } alt="" />
                  </Link>
                </div>
              </>
            ) : (
              <>
                <Nav.Link className="navbtn-navbar" as={Link} to="/register">
                  <button>تسجيل</button>
                </Nav.Link>
                <Nav.Link className="navbtn-navbar" as={Link} to="/login">
                  <button>دخول</button>
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarPro;
